export default "__VITE_ASSET__71539f63__"